module.exports = __webpack_public_path__ + "static/media/cat5.b04dcb01.png";